import * as PropTypes from "prop-types";
import React from "react";
import {Col, Row, Skeleton, Typography} from "antd";
import ReactCountryFlag from "react-country-flag";
import './Image.css';

const { Text} = Typography;

const NumberPlate = ({ loading, countryCode, registrationNo, alternativeReg }) => {

    // Use country code to get flag (country or EU or null if no flag) and number plate country code (or null if no number plate code)
    let flagCountryCode = null;
    let flagImage = null;
    let noPlateCountryCode = null;
    let mainColour = '#ffffff';
    let bannerColour = null; 

    switch(countryCode) {
        case "IE":
            noPlateCountryCode = "IRL";
            flagCountryCode = "EU";
            bannerColour = '#039';
            break;
        case "EE":
            noPlateCountryCode = "EST";
            flagCountryCode = "EU";
            bannerColour = '#039';
            break;
        case "FR":
            noPlateCountryCode = "F";
            flagCountryCode = "EU";
            bannerColour = '#039';
            break;
        case "PL":
            noPlateCountryCode = "PL";
            flagCountryCode = "EU";
            bannerColour = '#039';
            break;
        case "LI":
            noPlateCountryCode = "LT";
            flagCountryCode = "EU";
            bannerColour = '#039';
            break;
        case "LT":
            noPlateCountryCode = "LV";
            flagCountryCode = "EU";
            bannerColour = '#039';
            break;
        case "IT":
            noPlateCountryCode = "I";
            flagCountryCode = "EU";
            bannerColour = '#039';
            break;
        case "GB":
            noPlateCountryCode = "GB";
            flagCountryCode = "GB";
            mainColour = '#e9b001';
            bannerColour = '#039';
            break;
        default:

    }
    if(flagCountryCode)
    {
        flagImage = <ReactCountryFlag countryCode={flagCountryCode} svg  style={{ width: '2em',   height: '1.5em' }} />;
    }

    let cssClass = "dp-number-plate-right";
    if(alternativeReg)
    {
        cssClass = "dp-number-plate-right-2rows";
    }
    const showReg = alternativeReg ? alternativeReg : registrationNo;

    return (
        <div>
            <Row className="dp-number-plate">
                { flagImage || noPlateCountryCode
                  ?
                <Col className="dp-number-plate-left" style={{ backgroundColor: bannerColour }} >
                    <Row justify="center" align="middle" className="dp-number-plate-country-flag">
                        {loading
                         ? <></>
                         : flagImage || <></> }
                    </Row>
                    <Row justify="center" align="middle" className="dp-number-plate-country-text">
                        {loading
                          ? <></>
                          : (noPlateCountryCode
                             ?  <Text>{noPlateCountryCode}</Text>
                             : <></> ) }
                    </Row>
                </Col>
                  : <></> }
                <Col className={cssClass} style={{ backgroundColor: mainColour }}>
                    <Row justify="center" align="middle">
                        {loading
                         ? <Skeleton title={true} paragraph={null} active />
                         : <Text className="dp-number-plate-text">{showReg}</Text>}
                    </Row>
                </Col>
            </Row>
        </div>
    );
}

// Validate prop type parameters.
NumberPlate.propTypes = {
    loading: PropTypes.bool,
    countryCode: PropTypes.string,
    registrationNo: PropTypes.string,
    alternativeReg: PropTypes.string,
    bannerColour: PropTypes.string,
    mainColour: PropTypes.string,
};

NumberPlate.defaultProps = {
    loading: false,
    countryCode: 'GB',
    registrationNo: '',
    alternativeReg: null,
    bannerColour: '#003aa4',
    mainColour: '#e9b001'
};

export default NumberPlate;